import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()(() => ({
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
